import type {
  CreateProductDTO,
  UpdateProductDTO,
} from "@/modules/products/domain/contracts";

export type ProductFormPayload = {
  categoryIds: string[];
  name: string;
  slug?: string;
  description?: string | null;
  imageKey?: string | null;
  isActive?: boolean;
  lowStockThreshold?: number;
};

/** แปลงค่าฟอร์มสินค้า → payload API สินค้า (ไม่มี variants) */
export function toProductApiPayload(
  vals: ProductFormPayload,
): CreateProductDTO & UpdateProductDTO {
  return {
    categoryIds: vals.categoryIds,
    name: vals.name,
    slug: vals.slug,
    description: vals.description || null,
    imageKey: vals.imageKey || null,
    isActive: vals.isActive,
    lowStockThreshold: vals.lowStockThreshold,
  };
}

/** @deprecated ใช้ toProductApiPayload — คงชื่อเดิมไว้ชั่วคราว */
export function splitProductFormValues(vals: ProductFormPayload): {
  product: CreateProductDTO & UpdateProductDTO;
} {
  return { product: toProductApiPayload(vals) };
}
